import { render, staticRenderFns } from "./iTextAreaField.vue?vue&type=template&id=be1a3940&"
import script from "./iTextAreaField.vue?vue&type=script&lang=js&"
export * from "./iTextAreaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports